howspace.login.customer = (() => {
    'use strict';

    if (!real.dom.$body.hasClass('customer-login')) {
        return {};
    }

    let goToUrl = real.baseUri;
    let params = window.location.search.substring(1).split('&');
    params.forEach(function(tuple) {
        tuple = tuple.split('=');
        if(tuple[0] === 'uri') {
            goToUrl += decodeURIComponent(tuple[1]);
        }
    });

    const emailInput = $('#email');

    emailInput.on('input', e => {
        howspace.form.clearInvalidField(emailInput);
        $('.login-btn').prop('disabled', emailInput.val().trim() === '');
    });

    emailInput.on('keydown', e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            $('.login-btn').trigger('click');
        }
    });

    $('.login-btn').on('click', e => {
        const btn = $(e.currentTarget);
        real.button.loading(btn, $('.login-form'));

        const dataPayload = {
            email : $('#email').val()
        };

        real.ajax.json(real.baseUri + '/sessions/start', {
            type : 'POST',
            data : JSON.stringify(dataPayload),
            waitForWebsocket : false,
            showErrorNotification : false,
            logError : false,
            success : () => {
                $('.login-form').addClass('d-none');
                $('.pin-entry').removeClass('d-none');
                $('.howspace-form-number-input')[0].focus();
            },
            error : response => {
                real.ajax.loopErrors(response, function(error) {
                    howspace.form.markInvalidField(emailInput, error.message);
                });
            },
            complete : () => {
                real.button.reset(btn, $('.login-form'));
                emailInput.trigger('focus');
            }
        });
    });

    $('.retry-btn').on('click', e => {
        $('.login-form').removeClass('d-none');
        $('.pin-entry').addClass('d-none');
        $('#email').val('').trigger('input');
        howspace.components.otpInput.reset($('.howspace-form-otp-input'));
    });

    return {};
})();
